// Numbers as the page shows them: points with a comma every three digits (the page is in English). Not
// toLocaleString: its first call loads the browser's number formatting, ~30 ms on a slow phone, and the
// table's first render paid it (design 11 §3).
export const num = (n: number): string => (n < 0 ? "-" : "") + String(Math.abs(Math.trunc(n))).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
